import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  body: {
    overflow: 'hidden'
  },

  modalWrapper: {
    display: 'none',
    zindex: 1400,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      outline: 'none',
      position: 'relative',
      zIndex: 1,
      width: 280,
      height: '100vh',
      maxHeight: '100vh',
      overflow: 'hidden'
    }
  },

  desktopMenuWrapper: {
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  securityContainer: {
    fontSize: 16,
    width: '100vw',
    display: 'flex',
    overflow: 'hidden',
    color: theme.palette.text.secondary,
    fallbacks: {
      height: '100vh'
    },
    height: '100dvh'
  },
  securityViewContainer: {
    flex: '1 1 auto',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 56
    }
  },

  showMenuIcon: {
    marginLeft: 8,
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  securityTitle: {
    margin: '0 16px 16px 0',
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  securityMain: {
    height: '100%',
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    '-webkit-overflow-scrolling': 'touch',

    '@media (min-width:961px)': {
      paddingLeft: 240
    }
  }
}))
